module.exports = __webpack_public_path__ + "static/media/futureIcon.de0c199f.png";